import { render, staticRenderFns } from "./AncientChineseLiterature.vue?vue&type=template&id=c36680b2&scoped=true&"
import script from "./AncientChineseLiterature.vue?vue&type=script&lang=js&"
export * from "./AncientChineseLiterature.vue?vue&type=script&lang=js&"
import style0 from "./AncientChineseLiterature.vue?vue&type=style&index=0&id=c36680b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36680b2",
  null
  
)

export default component.exports